import React, {CSSProperties, FC} from 'react'
import * as styles from './skeletonStyle.module.css'

interface skeletonPropStyle {
    style?: CSSProperties
}
const Skeleton: FC<skeletonPropStyle> = ({style}) => {
    return <span className={styles['tile-skeleton']} style={{...style}} />
}

export default Skeleton
